import React from 'react';
import { Navigate } from 'react-router-dom';

export default function AgendaRouterPage() {
  return <Navigate to="/agenda" replace />;
}
